import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avator',
  standalone: true,
})
export class AvatorPipe implements PipeTransform {
  transform(fullName: string | undefined = '', numChars: number = 2): string {
    if (fullName === 'undefined') {
      return 'A';
    }
    return fullName
      .split(' ')
      .slice(0, numChars)
      .map(n => n[0]?.toUpperCase())
      .join('');
  }
}
